import { render } from "./ModalRestoreQuizSended.vue?vue&type=template&id=5026f37c"
import script from "./ModalRestoreQuizSended.vue?vue&type=script&lang=js"
export * from "./ModalRestoreQuizSended.vue?vue&type=script&lang=js"

import "./ModalRestoreQuizSended.vue?vue&type=style&index=0&id=5026f37c&lang=css"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__